(function() {
    angular
        .module("feedbackModule")
        .config(feedbackRouter)

    feedbackRouter.$inject = [
        "$stateProvider",
        "$urlRouterProvider",
        "$locationProvider"
    ]

    function feedbackRouter(
        $stateProvider,
        $urlRouterProvider,
        $locationProvider
    ){
        $stateProvider
            .state("feedback", {
                url: "/feedback",
                templateUrl: "app/components/feedback/feedback.view.html",
                controller : "FeedbackController"
            })
            .state("feedback-details", {
                url: "/feedback/details/id/:feedback_id",
                templateUrl: "app/components/feedback/details.view.html",
                controller : "FeedbackDetailsController"
            })

            $urlRouterProvider.otherwise("/")

        $locationProvider.html5Mode(true)
    }
})()
